import Typography from '../Atoms/Typography';
import useViewTestResult from '../../hooks/Onboarding/useViewTestResult';
import { Icon } from '../Icons';

import { isEnterPressed } from 'utils/keyboard';

function ViewTestResult() {
  let {
    getJobList,
    hypertestJobList,
    currentConfiguration,
    handleDocLinkClick,
  } = useViewTestResult();
  let isJobAvialbale =
    hypertestJobList &&
    hypertestJobList.data &&
    hypertestJobList.data.data &&
    hypertestJobList.data.data.length === 0;
  if (hypertestJobList && hypertestJobList.error) {
    isJobAvialbale = true;
  }
  let isYamlBasedSample =
    currentConfiguration.testType !== 'sampleTest' ? true : false;
  return (
    <div className="ltw-mt-30px ltw-items-center ltw-gap-20px ltw-mb-10px">
      {isJobAvialbale && (
        <div className="ltw-flex ltw-gap-8px ltw-items-center ltw-mb-15px">
          <Icon name="info-blue" width="14" height="14" color="#EA1A1A" />
          <Typography
            variant="h2"
            color="ltw-text-error-msg"
            fontSize="ltw-text-14"
            lineHeight="ltw-leading-17"
          >
            We couldn't detect a test yet. Did you run your test?
            <a
              target="_blank"
              className="ltw-text-primary"
              role="button"
              tabIndex="0"
              href="/#"
              onClick={handleDocLinkClick}
              onKeyDown={handleDocLinkClick}
            >
              {' '}
              View Docs
            </a>
          </Typography>
        </div>
      )}
      <div
        onClick={(e) => getJobList('')}
        onKeyDown={(e) => isEnterPressed(e) && getJobList('')}
        role="button"
        tabIndex="0"
        className={`ltw-flex ltw-gap-8px ltw-items-center ltw-justify-center ${
          isYamlBasedSample ? 'ltw-w-1/2' : ''
        }`}
      >
        <Typography
          variant="h2"
          color="ltw-text-primary"
          fontSize="ltw-text-14"
          lineHeight="ltw-leading-17"
          cursor="pointer"
        >
          View Test Results
        </Typography>
        <Icon name="redirect-horizontal-arrow" width="12" height="14" />
      </div>
    </div>
  );
}
export default ViewTestResult;
